export default __webpack_public_path__ + "static/media/banner.8a5be795.svg";